import { IntegrityListService } from './../core/service/grid-data/grid-data-integrity-batch.service';
import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { IntegrityListComponent } from './integrity-list/integrity-list.component';
import { IntegrityEditComponent } from './integrity-edit/integrity-edit.component';
import { IntegrityItemAddressListComponent } from './integrity-item-address-list/integrity-item-address-list.component';
import { IntegrityItemAddressListService } from '../core/service/grid-data/grid-data-integrity-item-address-list.service';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    IntegrityListComponent,
    IntegrityEditComponent,
    IntegrityItemAddressListComponent
  ],
  providers: [
    IntegrityListService,
    IntegrityItemAddressListService
  ],
})
export class IntegrityModule { }
